import apiClient from "./apiClient";

export const listUsers = () => apiClient.get("/users");
